import React from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import MsgNetLoading from '../components/MsgNetLoading';
import EventoList from '../components/EventoList';
import { FirebaseContext } from '../index';
import CONFIG from '../config';

class EventoListScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventosFirebase: [],
      eventosLive2: [],
      firebaseLoaded: false,
      live2Loaded: false
    };
    this.unlisten = null;
  }

  componentDidMount() {
    const { db } = this.props;

    const eventosQuery = query(
      collection(db, 'evento'),
      where('visible', '==', true),
      orderBy('fecha_inicio'),
      orderBy('hora_inicio')
    );

    this.unlisten = onSnapshot(eventosQuery, (snapshot) => {
      let eventos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ eventosFirebase: eventos, firebaseLoaded: true });
    });

    // Eventos del backend (next.resultados.live)
    if (CONFIG.LIVE2_API_URL) {
      fetch(`${CONFIG.LIVE2_API_URL}/api/1.0/live/eventos/`)
        .then(r => r.json())
        .then(eventos => {
          const live2 = eventos.map(e => ({
            ...e,
            _href: `${CONFIG.LIVE2_BASE_URL}/${e.id}`
          }));
          this.setState({ eventosLive2: live2, live2Loaded: true });
        })
        .catch(err => {
          console.error('live2 eventos error:', err);
          this.setState({ live2Loaded: true });
        });
    } else {
      this.setState({ live2Loaded: true });
    }
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  _mergeEventos() {
    const { eventosFirebase, eventosLive2 } = this.state;
    // Dedup: si un evento existe en Firebase (mismo nombre+fecha), no duplicar
    const fbKeys = new Set(eventosFirebase.map(e => e.nombre + '_' + e.fecha_inicio));
    const uniqueLive2 = eventosLive2.filter(e => !fbKeys.has(e.nombre + '_' + e.fecha_inicio));
    const merged = [...eventosFirebase, ...uniqueLive2];
    merged.sort((a, b) => (a.fecha_inicio || '').localeCompare(b.fecha_inicio || ''));
    return merged;
  }

  render() {
    if (!this.state.firebaseLoaded && !this.state.live2Loaded) {
      return <MsgNetLoading />;
    }
    return <EventoList eventos={this._mergeEventos()} />;
  }
}

function EventoListScreen() {
  const { db } = React.useContext(FirebaseContext);
  return <EventoListScreenClass db={db} />;
}

export default EventoListScreen;
